/**
 * RatingListContainer
 * --
 */
import React from 'react';
import RatingListPresenter from './RatingListPresenter';

const RatingListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <RatingListPresenter />
    </>
  );
};

export default RatingListContainer;
